import { v4 as uuid } from "uuid";
import { isArray, isEmpty } from "lodash";

const VARIABLE_INPUT_PATTERN = /\{(\w+)\}/g;

function convertFromAIGenerateToScript({content, position}) {
    const newPosition = { x: position.x, y: position.y };
    const nodes = []
    const edges = []
    const variables = new Set();
    let previousUuid = ''
    const MAX_NODE_IN_COLUMN = 6;
    const SPACE_X = 240;
    let currentIndexInColumn = 0;
    let column = 1;

    for (const item of content) {
        currentIndexInColumn ++;
        const isLoopNode = item.type === 'forCode'
        let typeNode = "normalNode";
        let { data, selector, output, target, path, name, value } = item;
        data = typeof data === 'string' ? replaceToValidVariables(data, variables) : data;
        selector = selector?.replaceAll("xpath=", "");
        selector = selector?.replaceAll("xpath:", "");
        selector = replaceToValidVariables(selector, variables);
        output = replaceToValidVariables(output, variables);
        target = replaceToValidVariables(target, variables);
        path = replaceToValidVariables(path, variables);
        name = replaceToValidVariables(name, variables);
        value = replaceToValidVariables(value, variables);
        item.filePath = replaceToValidVariables(item.filePath, variables);
        if (item.data?.domain) {
            item.data.domain = replaceToValidVariables(item.data.domain, variables);
        }
        let node = {};
        const newUuid = uuid();
        let nodeSize = { width: 0, height: 0 }

        switch (item.type) {
            case "newTab":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "New tab",
                        icon: "IconExternalLink",
                        options: {
                            newTab: data || ""
                        },
                        search: "New tab"
                    },
                }
                break;
            case "activeTab":
                nodeSize = { width: 120, height: 46 };
                node = {
                    id: "2acea61f-1700-4567-8d7c-26b10ce33744",
                    data: {
                        label: "Active tab",
                        icon: "IconLayersLinked",
                        options: {
                            title: "url",
                            comparison: "equal",
                            tabInfo: data || ""
                        },
                        search: "Active tab"
                    },
                }
                break;
            case "closeTab":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Close tab",
                        icon: "IconSquareX",
                        options: {
                            closeTabType: data,
                            tabNumber: 1
                        },
                        search: "Close tab"
                    },
                }
                break;
            case "openUrl":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Open url",
                        icon: "IconLink",
                        options: {
                            url: data,
                            timeout: 30000,
                            waitUntil: "domcontentloaded",
                            referer: ""
                        },
                        search: "Open url"
                    },
                }
                break;
            case "reloadPage":
                nodeSize = { width: 131, height: 46 };
                node = {
                    data: {
                        label: "Reload page",
                        icon: "IconRefresh",
                        options: {
                            reload: true,
                            timeout: 30000
                        },
                        search: "Reload page"
                    },
                }
                break;
            case "screenShot":
                nodeSize = { width: 123, height: 46 };
                node = {
                    data: {
                        label: "Screenshot",
                        icon: "IconScreenshot",
                        options: {
                            screen_shot_name: "1740545565233",
                            isFullScreen: false,
                            type_format: "jpeg",
                            modeSave: "default",
                            path_folder: path
                        }
                    },
                }
                break;
            case "switchFrame":
                nodeSize = { width: 136, height: 46 };
                node = {
                    data: {
                        label: "Switch Frame",
                        icon: "IconFrame",
                        options: {
                            elementSelect: data,
                            frame: "subFrame",
                            timeout: "30000"
                        }
                    },
                }
                break;
            case "switchExtensionPopup":
                nodeSize = { width: 196, height: 46 };
                node = {
                    data: {
                        label: "Switch Extension popup",
                        icon: "IconPuzzle",
                        options: {
                            switchPage: "extensionPopupPage",
                            elementSelect: data,
                            timeout: 30000
                        }
                    },
                }
                break;
            case "goBack":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Go back",
                        icon: "IconArrowBadgeLeft",
                        options: {
                            timeout: 0
                        },
                        search: "Go back"
                    },
                }
                break;
            case "click":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Click",
                        icon: "IconHandClick",
                        options: {
                            button: "left",
                            buttonClick: "click",
                            selectorType: "selector",
                            elementSelect: selector,
                            elementOrder: "fixed",
                            fixedElement: 1,
                            randomElementFrom: 1,
                            randomElementTo: 50,
                            x: 0,
                            y: 0
                        },
                        search: "Click"
                    },
                }
                break;
            case "mouseMovement":
                nodeSize = { width: 164, height: 46 };
                node = {
                    data: {
                        label: "Mouse movement",
                        icon: "IconDragDrop",
                        options: {
                            selectorType: "selector",
                            elementSelect: selector,
                            elementOrder: "fixed",
                            fixedElement: 1,
                            randomElementFrom: 1,
                            randomElementTo: 50,
                            x: 0,
                            y: 0,
                            focus: false
                        },
                        search: "Mouse movement"
                    },
                }
                break;
            case "scroll":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Scroll",
                        icon: "IconGripVertical",
                        options: {
                            selectorType: "selector",
                            elementSelect: selector,
                            fixedElement: 1,
                            deltaX: 0,
                            deltaY: 0
                        },
                        search: "Scroll"
                    },
                }
                break;
            case "drop-down-selector":
                nodeSize = { width: 174, height: 46 };
                node = {
                    data: {
                        label: "Drop-down selector",
                        icon: "IconSelect",
                        options: {
                            elementSelect: selector,
                            elementOrder: 'fixed',
                            fixedElement: 1,
                            randomElementFrom: 1,
                            randomElementTo: 50,
                            selectedValue: value,
                        },
                        search: "Drop-down selector"
                    },
                }
                break;
            case "mouseWheel":
                nodeSize = { width: 136, height: 46 };
                node = {
                    data: {
                        label: "Mouse wheel",
                        icon: "IconMouse",
                        options: {
                            deltaX: 0,
                            deltaY: target,
                        },
                        search: "wheel"
                    },
                }
                break;
            case "pressKey":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Press key",
                        icon: "IconKeyboardShow",
                        options: {
                            pressKey: data?.split(",").map(i => i.trim()),
                        },
                        search: "Press key"
                    },
                }
                break;
            case "typeText":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Type text",
                        icon: "IconBallpen",
                        search: "Type text",
                        options: {
                            intervalTime: 100,
                            typeText: data,
                        },
                    },
                }
                break;
            case "sendTextToSelector":
                nodeSize = { width: 177, height: 46 };
                node = {
                    data: {
                        label: "Send text to selector",
                        icon: "IconAlphabetLatin",
                        options: {
                            elementSelect: selector,
                            fixedElement: 1,
                            content: data,
                            contentType: "sequence",
                            intervalTime: 100,
                            timeout: 30000
                        },
                        search: "Send text to selector"
                    },
                }
                break;
            case "elementExists":
                nodeSize = { width: 141, height: 46 };
                node = {
                    data: {
                        label: "Element exists",
                        icon: "IconMinimize",
                        options: {
                            elementSelect: selector,
                            fixedElement: 1,
                            isVisible: "true",
                            timeout: 30000
                        },
                        search: "Element exists"
                    },
                }
                break;
            case "getUrl":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Get URL",
                        icon: "IconLine",
                        options: {
                            extractionType: "fullUrl",
                            searchKeyValue: "",
                            dataUrl: output,
                        },
                        search: "Get URL"
                    },
                }
                break;
            case "getText":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Get text",
                        icon: "IconFileDots",
                        options: {
                            elementSelect: selector,
                            elementOrder: "fixed",
                            fixedElement: 1,
                            randomElementFrom: 1,
                            randomElementTo: 50,
                            outputVariable: output
                        },
                        search: "Get text"
                    },
                }
                break;
            case "getAttributeValue":
                nodeSize = { width: 166, height: 46 };
                node = {
                    data: {
                        label: "Get attribute value",
                        icon: "Icon3dCubeSphere",
                        options: {
                            attributeName: item.attribute,
                            outputVariable: output,
                            elementSelect: selector,
                            elementOrder: "fixed",
                            fixedElement: 1,
                            randomElementFrom: 1,
                            randomElementTo: 50
                        },
                        search: "Get attribute value"
                    },
                }
                break;
            case "random":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Random",
                        icon: "IconArrowsRandom",
                        options: {
                            count: 1,
                            from: item.data?.from,
                            mode: item.mode,
                            outputVariable: item?.outputVariable,
                            password: 8,
                            to: item.data?.to,
                            domain: item.data?.domain,
                        },
                        search: "Random"
                    },
                }
                break;
            case "pauseCode":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Pause",
                        icon: "IconPlayerPause",
                        options: {
                            description: data + " ms",
                            typePauseState: "exactTime",
                            exactTimeState: data,
                            fromTimeState: 0,
                            toTimeState: 0
                        },
                        search: "Random"
                    },
                }
                break;
            case "addLog":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Add log",
                        icon: "IconArticle",
                        options: {
                            content: data,
                        },
                        search: "Random"
                    },
                }
                break;
            case "readFile":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Read file",
                        icon: "IconFileInfo",
                        options: {
                            filePath: item.filePath || "",
                            outputVariable: item.outputVariable || "",
                            readType: item.readType || "",
                            random: item.random || false,
                            delAfterRead: item.delAfterRead || false,
                            lineByLineDelimiter: "",
                            multiOutputVariable: [],
                        },
                        search: "Read file"
                    },
                }
                break;
            case "writeFile":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Write file",
                        icon: "IconFileInfinity",
                        options: {
                            filePath: item.filePath || "",
                            inputVariable: data || "",
                            writeMode: item.writeMode || "overwrite",
                            selectorType: "txt",
                            appendMod: "newline",
                            lineByLineDelimiterTxt: "",
                            lineByLineDelimiter: "",
                        },
                        search: "Read file"
                    },
                }
                break;
            case "fileChoose":
                nodeSize = { width: 159, height: 46 };
                node = {
                    data: {
                        label: "File choose event",
                        icon: "IconUpload",
                        options: {
                            attachment: "localFile",
                            filePath: item.filePath,
                            folderPath: '',
                            timeout: 30000,
                        },
                        search: "File choose event"
                    },
                }
                break;
            case "fileUpload":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "File upload",
                        icon: "IconUpload",
                        options: {
                            elementSelect: item.elementSelect,
                            fixedElement: 1,
                            attachment: "localFile",
                            filePath: item.filePath,
                            timeout: 30000,
                        },
                        search: "File upload"
                    },
                }
                break;
            case "evalCode":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Eval",
                        icon: "IconCode",
                        options: {
                            scriptCode: item.scriptCode || "",
                            injectVariable: item.injectVariable || "",
                            outputType: "AUTO",
                            outputVariable: "",
                        },
                        search: "Eval code"
                    },
                }
                break;
            case "readMail":
                nodeSize = { width: 158, height: 46 };
                node = {
                    data: {
                        label: "IMAP (Read mail)",
                        icon: "IconMail",
                        options: {
                            imapHost: item.imapHost,
                            imapPort: item.imapPort,
                            email: item.email,
                            password: item.password,
                            unseenMailOnly: item.unseenMailOnly || false,
                            markMailAsRead: item.markMailAsRead || false,
                            getLatestMail: item.getLatestMail || false,
                            outputVariable: item.outputVariable,
                            timeout: 30000,
                            tlsSecure: true,
                            mailBox: 'INBOX',
                            contentRegex: '',
                            mailContains: '',
                            mailService: 'custom',
                            outputMode: 'filter',
                            contentMailContains: '',
                        },
                        search: "IMAP (Read mail)"
                    },
                }
                break;
            case "readMailOauth2":
                nodeSize = { width: 198, height: 46 };
                node = {
                    data: {
                        label: "Outlook Mailer (oAuth2)",
                        icon: "IconMailFast",
                        options: {
                            authType: item.authType || 'LOGIN',
                            // OAuth2 fields (Microsoft Graph API)
                            client_id: item.client_id || '',
                            scope: item.scope || 'Mail.Read',
                            refresh_token: item.refresh_token || '',
                            grant_type: item.grant_type || 'refresh_token',
                            email: item.email || '',
                            // Legacy fields
                            password: item.password || '',
                            // Mail configuration
                            mailBox: 'INBOX',
                            markMailAsRead: item.markMailAsRead || false,
                            getLatestMail: item.getLatestMail || true,
                            subjectFilter: '',
                            contentRegex: '',
                            timeout: 30000,
                            outputVariable: item.outputVariable || "",
                            contentMailContains: '',
                            refreshTokenOutput: item.refreshTokenOutput || "",
                        },
                        search: "Read Mail"
                    },
                }
                if (item.refreshTokenOutput) {
                    variables.add(item.refreshTokenOutput);
                }
                break;
            case "http":
                nodeSize = { width: 120, height: 46 };
                node = {
                    data: {
                        label: "Http",
                        icon: "IconFileInfinity",
                        options: {
                            contentType: "application/json",
                            url: item.url,
                            method: item.method,
                            headers: [],
                            cookies: [],
                            dataString: "",
                            outputBodyVariables: [],
                            outputHeadersVariables: [],
                            outputCookiesVariables: [],
                        },
                        search: "Http"
                    }
                }
                if (typeof item.body === 'object') {
                    node.data.options.dataString = JSON.stringify(item.body);
                } else if (typeof item.body === 'string') {
                    node.data.options.dataString = item.body;
                }
                if (isArray(item.headers) && !isEmpty(item.headers)) {
                    node.data.options.headers = item.headers.map(i => ({ ...i, id: uuid() }))
                }
                if (typeof item.outputBodyVariables === 'string') {
                    try {
                        item.outputBodyVariables = JSON.parse(item.outputBodyVariables);
                    } catch (error) {}
                }
                if (isArray(item.outputBodyVariables) && !isEmpty(item.outputBodyVariables)) {
                    node.data.options.outputBodyVariables = item.outputBodyVariables.map(i => {
                        variables.add(i.value);
                        return { ...i, id: uuid() }
                    })
                }
                break;
            case "forCode":
                newPosition.x = newPosition.x + SPACE_X;
                newPosition.y = position.y;
                currentIndexInColumn = 0;
                typeNode = "nodeLoop";
                nodeSize = { width: 90, height: 90 };
                node = {
                    data: {
                        label: "For",
                        icon: "IconRepeat",
                        options: {
                            selectorTypeLoop: item.selectorTypeLoop,
                            elementSelect: item.elementSelect,
                            loopItemSave: item.loopItemSave,
                            loopIndexSave: item.loopIndexSave || '',
                            times: item.selectorTypeLoop === "times" ? data: '',
                            extractionType: "text",
                            extractionTypeFill: "",
                            fromValue: "",
                            toValue: "",
                        },
                        search: "Loop"
                    }
                }
                if (item.loopIndexSave) {
                    variables.add(item.loopIndexSave);
                }
                if (item.loopItemSave) {
                    variables.add(item.loopItemSave);
                }
                break;
            default:
                console.log("Invalid type: ", item);
                break;
        }

        node.positionAbsolute = { ...newPosition };
        node.position = { ...newPosition };
        node.id = newUuid;
        node.width = nodeSize.width;
        node.type = typeNode;
        node.height = nodeSize.height;
        node.selected = true;
        node.dragging = false;

        node.data.type = item.type;
        node.data.version = 0;
        node.data.typeNode = typeNode;
        node.data.options.nodeSetting = {
            fromTimeSleep: 3000,
            toTimeSleep: 7000,
        }
        if (node.data.options?.outputVariable) {
            variables.add(node.data.options.outputVariable);
        }
        nodes.push(node)
        if (previousUuid) {
            edges.push({
                source: previousUuid,
                sourceHandle: `success-${previousUuid}`,
                target: `${newUuid}`,
                targetHandle: isLoopNode ? `above-${newUuid}` : `in-${newUuid}`,
                type: "customEdge",
                style: { stroke: "var(--output)" },
                data: {},
                id: `reactflow__edge-${previousUuid}out-${previousUuid}-${newUuid}in-${newUuid}`,
            });
        }
        previousUuid = newUuid;
        if (isArray(item.script) && !isEmpty(item.script)) {
            newPosition.y = position.y + (nodeSize.height*2);
            const childResult = convertFromAIGenerateToScript({ content: item.script, position: newPosition });
            nodes.push(...childResult.nodes);
            edges.push(...childResult.edges);
            const lastNewNodesIndex = childResult.nodes.length - 1;
            edges.push({
                source: newUuid,
                sourceHandle: `out-${newUuid}`,
                target: `${childResult.nodes[0].id}`,
                targetHandle: `in-${childResult.nodes[0].id}`,
                type: "customEdge",
                style: { stroke: "var(--output)" },
                data: {},
                id: `reactflow__edge-${newUuid}out-${newUuid}-${childResult.nodes[0].id}in-${childResult.nodes[0].id}`,
            });
            edges.push({
                source: childResult.nodes[lastNewNodesIndex].id,
                sourceHandle: `success-${childResult.nodes[lastNewNodesIndex].id}`,
                target: newUuid,
                targetHandle: `below-${newUuid}`,
                type: "customEdge",
                style: { stroke: "var(--output)" },
                data: {},
                id: `reactflow__edge-${childResult.nodes[lastNewNodesIndex].id}success-${newUuid}below-${newUuid}`,
            });
            if (childResult.variables) {
                childResult.variables.forEach(i => variables.add(i))
            }
        }
        if (isLoopNode) {
            newPosition.y = position.y
            newPosition.x = newPosition.x + SPACE_X;
        } else if (currentIndexInColumn >= MAX_NODE_IN_COLUMN) {
            currentIndexInColumn = 0;
            newPosition.y = position.y;
            newPosition.x = newPosition.x + SPACE_X;
            column++;
        } else {
            newPosition.y = newPosition.y + nodeSize.height * 2;
        }
    }

    return { nodes: nodes, edges: edges, variables: variables, position: newPosition }
}

function replaceToValidVariables(value, variables) {
    if (typeof value === 'string') {
        const variable = value.match(/\{(\w+)\}/);
        if (variable?.[1]) {
            variables.add(variable[1]);
        }
        return value.replaceAll(VARIABLE_INPUT_PATTERN, '${$1}');
    }
    return value;
}

export { convertFromAIGenerateToScript };
